var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('FullLoader',{attrs:{"showLoader":_vm.$store.state.isShowedLoadderScreen}}),_c('ErrorModal',{attrs:{"showModal":_vm.$store.getters.hasErrors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }